import { mapGetters } from "vuex";
import * as types from "@/store/types";

const mobileInputComponent = () =>
  import(/* webpackChunkName: "count-down" */ "./Mobile/index");

const emailInputComponent = () =>
  import(/* webpackChunkName: "count-down" */ "./Email/index");

const phoneInputComponent = () =>
  import(/* webpackChunkName: "count-down" */ "./Phone/index");

export default {
  name: "personal-contact",
  components: {
    mobileInputComponent,
    emailInputComponent,
    phoneInputComponent
  },
  computed: {
    ...mapGetters({
      userInfo: types.userInfo.getters.GET_USER_INFO,
      userVerify: types.userVerifyInfo.getters.GET_USER_VERIFY_INFO
    }),
    isHomePhoneSubmitted() {
      return (
        this.userVerify?.is_home_phone_submitted ||
        this.userVerify?.is_home_phone_verified
      );
    },
    isMobileVerify() {
      return this.userVerify?.is_mobile_verified;
    },
    isEmailVerify() {
      return this.userVerify?.is_email_verified;
    },
    activeButton() {
      if (
        this.isMobileVerify &&
        this.isEmailVerify &&
        this.isHomePhoneSubmitted
      )
        return false;
      return true;
    }
  },
  methods: {
    continueKyc() {
      this.$router.push({ name: "personalInformation" });
    }
  }
};
